import Axios from "axios";
import React, { useState, useEffect } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { useTranslation } from "react-i18next";

export const DropDownRols = ({ value, idClient, ...props }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [defaultValue, setDefaultValue] = useState();

  async function getData() {
    const type = idClient === 1 ? 0 : 1;

    const res = await Axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/User/role/list/${type}`,
    );

    let tempArray = res.data.responseObject.map((item) => {
      item.label = item.name;
      item.value = item.id;
      return item;
    });
    setData(tempArray);
    const selected = tempArray.find((obj) => obj.id === value) || tempArray[0];

    if (selected) {
      props.onChange(selected);
    }

    setDefaultValue(selected);
  }

  useEffect(() => {
    getData();
  }, [value, idClient]);

  return (
    <Dropdown
      className={props.className}
      options={data}
      name={props.name}
      disabled={props.disabled}
      onChange={(item) => props.onChange(item)}
      value={defaultValue}
      placeholder={t("dropdowns.selectRole")}
    />
  );
};
